import { getComponentClasses } from '@99designs/frontend-components/utils/app/index';
import * as React from 'react';

interface Props {
    baseClass: 'heading' | 'paragraph';
    type?: 'p' | 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5';
    variations?: string[];
    children: React.ReactNode;
    style?: any;
    className?: string;
}

export default function Text({
    baseClass,
    type = 'p',
    variations,
    style,
    children,
    className = '',
}: Props) {
    const variantionsClassName = getComponentClasses(baseClass, variations ? variations : []);
    const classNameWithVariations = className
        ? `${className} ${variantionsClassName}`
        : variantionsClassName;
    return React.createElement(
        type,
        { className: classNameWithVariations, style: style },
        children
    );
}
